export class CustomerSecurityComplianceDTO{
    public customerId!: number;
    public dataRetentionMonths!: number;
    public twoFactorMandated!: boolean;
}